<template>
  <div class="container-fluid mt-2">
    <h1>Datenquellen</h1>
    <div class="btn-toolbar" role="toolbar">
      <button @click="create" id="ds-new" class="btn btn-primary"><font-awesome-icon icon="plus"/>&nbsp;Neue Datenquelle</button>
    </div>
    <div class="row mt-3">
      <div class="col-md">
          <div class="form-group">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">Name:</span>
              </div>
              <input v-model="name" type="text" class="form-control" id="ds-name"/>
              <div class="input-group-append">
                <button @click="validate" id="ds-check" class="btn btn-success"><font-awesome-icon icon="check-circle"/>&nbsp;Validieren</button>
                <button id="ds-save" @click="save" class="btn btn-primary"><font-awesome-icon icon="save"/>&nbsp;Speichern</button>
              </div>
            </div>
          </div>
        <div class="container card p-3" id="ds-editor">
          <DataSourceEditor ref="sources"/>
        </div>
      </div>
      <div class="col-md">
        <ul id="dslist" class="list-group mb-3">
          <li class="list-group-item" v-for="s in sources" :key="s.name">
            <div style="float:left;">
              <h6 class="my-0">{{ s.name }}</h6>
              <small class="text-muted">Typ: {{ s.type }}</small>
            </div>
            <div style="float:right;">
              <div class="btn-group">
                <button @click="open(s)" colid="0" name="ds-edit" class="btn btn-sm btn-secondary">Bearbeiten</button>
                <button @click="deleteSource(s)" colid="0" name="ds-delete" class="btn btn-sm btn-danger"><font-awesome-icon icon="trash"/></button>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import datamap from '@/modules/datamap.js'
import DataSourceEditor from '@/components/genericdata/DataSourceEditor.vue'

export default {
  name: 'DataSourcesView',
  components: {
    DataSourceEditor
  },
  data() {
    return {
      name: "",
      sources: []
    }
  },
  created: function() {
    this.fetchData();
  },
  methods: {
    create: function() {
      this.name = 'NewDatasource1';
      this.$refs.sources.setSource({});
    },
    open: function(item) {
      this.name = item.name;
      this.$refs.sources.setSource(item.config);
    },
    validate() {
      var data = this.$refs.sources.getSource();
      var config = { name: this.name,config:data,type: data.type };
      var self = this;
      datamap.checksource(this,JSON.stringify(config),function(resp) {
        console.log('validated:',resp);
        var variant = resp.result == 'error' ? "danger" : "success";
        self.$bvToast.toast('Validierung: ' + (resp.error || "Alles in Ordnung"),{title:'Datenquelle prüfen', variant:variant});
      });

    },
    deleteSource: function(s) {
      if (confirm('Datenquelle ' + s.name + ' wirklich löschen?')) {
        var self = this;
        datamap.deletesource(this,s.name, function() {
          self.$bvToast.toast('Datenquelle gelöscht.',{title: 'Datenquellen',variant: 'success'})
          self.fetchData();
        });
      }
    },
    save: function() {
      if (this.name == '') {
        this.$bvToast.toast('Bitte erst einen Namen angeben.',{variant:"warning",title:"Warnung"});
        return;
      }
      console.log(this.$refs.sources);
      var data = this.$refs.sources.getSource();
      var config = { name: this.name,config:data,type: data.type };
      console.log(config);
      var self = this;
      datamap.savesource(this,JSON.stringify(config),function() {
        self.$bvToast.toast('Datenquelle speichern',{variant: "success",title:'Fertig'});
        self.fetchData();
      });
    },
    fetchData: function() {
      var self = this;
      datamap.listsources(this,0,1000,function(data) {
        self.sources = data;
      })
    }
  }
}
</script>
